import { useEffect, useState } from "react";
import axios from "axios";

// Opções do filtro de Pagamento da tela de Pedidos: formas do sistema + as
// cadastradas pela loja + as que aparecem nos pedidos, uma por grupo ("Cartão",
// "cartao" e "cartao_<loja>" são uma opção só). Vem do servidor para usar a
// mesma chave que o resumo filtra. Antes a lista era fixa e comparada por
// igualdade exata — quase nenhum pedido casava, e "Múltiplo" era uma opção.
export function useOpcoesPagamento(api) {
  const [opcoes, setOpcoes] = useState([]);
  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const tok = localStorage.getItem("token");
        const res = await axios.get(`${api}/pedidos/formas-pagamento`, {
          headers: tok ? { Authorization: `Bearer ${tok}` } : {},
        });
        if (vivo) setOpcoes((res.data || []).map((o) => ({ value: o.chave, label: o.nome })));
      } catch (_) { /* sem opções: o filtro fica vazio, a lista continua */ }
    })();
    return () => { vivo = false; };
  }, [api]);
  return opcoes;
}
